import { render, staticRenderFns } from "./pill.vue?vue&type=template&id=e96da994&scoped=true&"
import script from "./pill.vue?vue&type=script&lang=js&"
export * from "./pill.vue?vue&type=script&lang=js&"
import style0 from "./pill.vue?vue&type=style&index=0&id=e96da994&prod&lang=less&"
import style1 from "./pill.vue?vue&type=style&index=1&id=e96da994&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96da994",
  null
  
)

export default component.exports